module.exports = __webpack_public_path__ + "img/faxIcon.ed64faee.svg";